import { FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { useParams } from "react-router";

import { BreedGroupJudgeApi, BreedGroupJudgeSearch, JudgeGridDto, JudgeSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { CustomDataTable, EmailButton, ExportButton } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { Link } from "react-router-dom";

export interface IBreedGroupJudgePageProps {}

export const BreedGroupJudgePage: React.FunctionComponent<IBreedGroupJudgePageProps> = (props) => {
  const { t } = useTl();
  const { id } = useParams<{ id: string }>();
  const breedGroupId = React.useMemo(() => +id, [id]);
  const api = useApiService(BreedGroupJudgeApi);
  const { currentLanguage } = useGlobalData();
  const [sobjState, setsobjState] = React.useState<any>();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [15, 25, 50],
    pageSize: 15,
    sortKeys: { name: "ASC" },
  });

  const { totalCount } = tableState;

  const searchFunction = React.useCallback(
    (sObj?: JudgeSearch) => {
      const sobj = BreedGroupJudgeSearch.fromJS({
        ...sObj,
        languageId: currentLanguage.languageId,
        breedGroupId: breedGroupId,
      });
      setsobjState(sobj);
      return api.baseSearch(sobj);
    },
    [api, breedGroupId, currentLanguage.languageId]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.LastName),
        fieldName: "name",
        render: (row: JudgeGridDto) => (
          <Link target="_blank" to={`${ERoutes.people}/${row.personId}/detail/view`}>
            {row.name}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Language),
        fieldName: "language",
      },
      {
        header: () => t(ETLCodes.Email),
        fieldName: "email",
        render: (value: JudgeGridDto) => <EmailButton email={value.email} />,
      },
      {
        header: () => t(ETLCodes.PhoneNumber),
        fieldName: "phoneNumber",
      },
      {
        header: () => t(ETLCodes.MobilePhoneNumber),
        fieldName: "mobilePhoneNumber",
      },
    ],
    [t]
  );
  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return (
    <FieldSet
      title={
        totalCount > 1
          ? t(ETLCodes.TableResults_Plural, { count: totalCount })
          : t(ETLCodes.TableResults, { count: totalCount })
      }
      rightElement={<ExportButton exportFunction={(sObj) => api.exportXlsFile(sObj)} sObj={sobjState} />}
    >
      <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
